import Backbone from '@polleverywhere/backbone'

function updateRoute (state, page, options) {
  const pageToRoute = _.invert(this.routes)

  if (_.has(pageToRoute, page)) {
    const route = pageToRoute[page]
    this.navigate(route, { trigger: false })
  }
}

/**
 * Updates URL when state changes. Also, update the state model
 * from the initial route.
 */
export default class Router extends Backbone.Router {
  get routes () {
    return {
      remote: 'remote',
      'presenter-controls': 'presenter-controls',
      reports: 'reports',
      participate: () => {
        this.state.set({ role: 'participant' })
      }
    }
  }

  initialize (options = {}) {
    _.defaults(options, {
      updateURL: true
    })

    this.state = options.state

    // Update route based on state changes
    if (options.updateURL) {
      // Wire up page changes to the browser url
      this.listenTo(this.state, 'change:page', updateRoute.bind(this))

      // If we hit a named route, update the url. e.g. settings, login, etc.
      this.on('route', (route, params) => {
        if (route.length) {
          this.state.changePage(route)
        }
      })
    }
  }
}
